import React, { ReactNode } from 'react';

interface PaneProps {
  children: ReactNode;
}

const Pane: React.FC<PaneProps> = ({ children }) => <>{children}</>;

export default Pane;
